module.exports = __webpack_public_path__ + "static/media/youTube.203794fe.png";